import { useState } from "react";
import { Button, Textarea } from "@material-tailwind/react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useMutation } from "react-query";
import { setSessionExpired, useMainController } from "../../../context";
import { toast } from "react-toastify";
import http, { httpPostProcessing } from "../../../services/http-common";

function RequestAppeal(props) {
  const [dispatch] = useMainController();
  const { open, toogleOpenEditor, id, docType } = props;
  const [notes, setNotes] = useState("");
  const [loading, setLoading] = useState(false);

  const errorFunc = (error) => {
    let message;
    message = error.response.data.message || error.message;
    toast.error(message);
  };

  const saveContent = useMutation(
    (id) => {
      return http.post(
        docType === "scientific" ? `train/book/appeal` : `law-docs/appeal`,
        {
          id: id,
          isAppeal: true,
          notes: notes,
        },
        setSessionExpired,
        dispatch
      );
    },
    {
      onSuccess: ({ data }) => {
        toast.success(data.message);
        toogleOpen();
      },
      onError: (error) => {
        errorFunc(error);
      },
      onMutate: () => {
        setLoading(true);
      },
      onSettled: () => {
        setLoading(false);
      },
    }
  );
  const saveWisdomContent = useMutation(
    (id) => {
      return httpPostProcessing.post(
        `wisdom-docs/appeal`,
        {
          id: id,
          isAppeal: true,
          notes: notes,
        },
        setSessionExpired,
        dispatch
      );
    },
    {
      onSuccess: ({ data }) => {
        toast.success(data.message);
        toogleOpen();
      },
      onError: (error) => {
        errorFunc(error);
      },
      onMutate: () => {
        setLoading(true);
      },
      onSettled: () => {
        setLoading(false);
      },
    }
  );

  const toogleOpen = () => {
    if (loading) return false;
    if (open) {
      setNotes("");
    }
    toogleOpenEditor();
  };

  const onChangeContent = (e) => {
    if (loading) return false;
    setNotes(e.target.value);
  };

  const onSubmit = () => {
    docType === "wisdom"
      ? saveWisdomContent.mutate(id)
      : saveContent.mutate(id);
  };

  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth={"sm"}
      onClose={toogleOpen}
      scroll={"paper"}
      animate={{
        mount: { scale: 1, y: 0 },
        unmount: { scale: 0.9, y: -100 },
      }}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
    >
      <DialogTitle id="scroll-dialog-title">Appeal for re-check</DialogTitle>
      <DialogContent dividers={true}>
        <form className="my-2 w-auto max-w-screen-md sm:w-96">
          <div className="mb-3">
            <label
              htmlFor="abstract"
              className="block text-sm font-medium text-gray-700"
            >
              Write Note
            </label>
            <Textarea
              id="abstract"
              name="notes"
              rows="3"
              label="Note"
              value={notes}
              onChange={onChangeContent}
              className="mt-1"
            />
          </div>
        </form>
      </DialogContent>
      <DialogActions className="space-x-2">
        <Button
          variant="text"
          size="sm"
          color="gray"
          className="mr-1 rounded-md waves-effect waves-light"
          onClick={toogleOpen}
          disabled={loading}
        >
          <span>Close</span>
        </Button>
        <Button
          size="sm"
          className="rounded-md waves-effect waves-light !bg-[#7a6fbe]"
          onClick={onSubmit}
          disabled={loading}
        >
          <span>Submit </span>
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default RequestAppeal;
